module.exports = {"tollFree":"Toll-free orders available at","tollFreeNumber":"1-866-967-8167","tollFreeNumberTel":"tel:18669678167","saveDraft":"Save draft","savePublish":"Save and publish","update":"Update","saveCoupon":"Save Coupon","createCoupon":"Create Coupon","saveFlexpass":"Save Flex Pass","createFlexpass":"Create Flex Pass"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/locales/fr.json
// module id = 788
// module chunks = 0